// components/GTMNoScript.js
const GTMNoScript = () => (
  <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-WCKDTTPR"
height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
);

export default GTMNoScript;
